import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { Reveal, SectionLabel, Magnetic } from "../components/primitives";
import { CONTACT } from "../data/site";

const Contact = () => (
  <div data-testid="contact-page" className="pt-[120px] md:pt-[150px] pb-28">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <SectionLabel>Contact</SectionLabel>
      <Reveal>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tighter max-w-3xl">
          Let's start a conversation.
        </h1>
      </Reveal>
      <div className="mt-16 grid lg:grid-cols-3 gap-6">
        {[
          { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
          { icon: Phone, label: "Phone", value: CONTACT.phones.map((p) => `+91 ${p}`).join("  ·  "), href: `tel:+91${CONTACT.phones[0]}` },
          { icon: MapPin, label: "Reach", value: "Pan-India delivery · 25+ states covered" },
        ].map((c, i) => (
          <Reveal key={c.label} delay={i * 0.08}>
            <div className="rounded-2xl border border-neutral-200 p-8 h-full hover:bg-[#f9f6f0] transition-colors">
              <c.icon size={22} className="text-[#f4b41a]" />
              <p className="mt-6 text-xs uppercase tracking-[0.2em] text-neutral-400">{c.label}</p>
              {c.href ? (
                <a href={c.href} className="mt-2 block font-display text-xl md:text-2xl font-medium tracking-tight link-underline">{c.value}</a>
              ) : (
                <p className="mt-2 font-display text-xl md:text-2xl font-medium tracking-tight">{c.value}</p>
              )}
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-14 rounded-2xl bg-neutral-900 text-white p-10 md:p-14 relative overflow-hidden">
        <div className="noise" />
        <div className="relative flex flex-wrap items-center justify-between gap-8">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight">Have a requirement?</h2>
            <p className="text-white/60 mt-2">Tell us what you're looking for and our team will help you build the right solution.</p>
          </div>
          <Magnetic>
            <Link to="/inquire" data-testid="contact-inquire-cta" className="group inline-flex items-center gap-2 rounded-full bg-[#f4b41a] text-neutral-900 font-semibold px-7 py-4 hover:bg-[#d99e12] transition-colors">
              Inquire Now <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Magnetic>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
